import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useParticipantIds, useDailyEvent, useDaily } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { remoteUsersAtom } from '../../State';

export default function DetectRemoteUsers({ isLiveViewer = false }) {
  const [remoteUsersState, setRemoteUsersState] = useRecoilState(remoteUsersAtom);

  const remoteUsers = useParticipantIds({
    filter: (user) =>
      (user.userData?.userType === 'owner' || user.userData?.userType === 'speaker') &&
      user.local == false,
    // filter: 'remote',
    // onParticipantJoined: (user) => {
    //   console.log(user.participant);
    //   if (isLiveViewer == false) {
    //     if (remoteUsersState.includes(user.participant.user_id) == false) {
    //       var newArray = remoteUsersState;

    //       // console.log('リモートユーザー情報');
    //       // console.log(user);
    //       // newArray.push(user.participant.user_id);
    //       // setRemoteUsersState(newArray);
    //     }
    //   } else {
    //     // if (remoteUsersState.includes(user.participant.user_id) == false) {
    //     //   //配列コピー
    //     //   var newArray = [];
    //     //   remoteUsersState.forEach((exitUser) => {
    //     //     newArray.push(exitUser);
    //     //   });
    //     //   // console.log('リモートユーザー情報');
    //     //   // console.log(user);
    //     //   newArray.push(user.participant.user_id);
    //     //   console.log('新しい');
    //     //   console.log(newArray);
    //     //   setRemoteUsersState(newArray);
    //     // }
    //     // if (user.participant.owner) {
    //     //   return true;
    //     // } else {
    //     //   return false;
    //     // }
    //   }
    // },
    // onParticipantLeft: (user) => {
    //   if (remoteUsersState.length > 0) {
    //     if (remoteUsersState.includes(user.participant.user_id)) {
    //       //配列コピー
    //       var newArray = [];
    //       remoteUsersState.forEach((exitUser) => {
    //         newArray.push(exitUser);
    //       });
    //       var result = newArray.filter(function (item) {
    //         return item !== user.participant.user_id;
    //       });

    //       setRemoteUsersState(result);
    //     }
    //   }
    // },
  });

  useEffect(() => {
    if (remoteUsers != null && remoteUsers.length > 0) {
      if (JSON.stringify(remoteUsers) != JSON.stringify(remoteUsersState)) {
        // console.log('リモートユーザー');
        // console.log(remoteUsers);
        setRemoteUsersState(remoteUsers);
      }
    } else {
      //console.log('ここは？');
      // console.log(remoteUsers.length);
      //if (remoteUsers.length >= 0) {
      setRemoteUsersState(null);
      //}
    }
  }, [remoteUsers]);

  //レンダービュー
  return false;
}
